import * as React from 'react';
import { ITEM_WIDTH_OVER_XL, ITEM_WIDTH_SP, VerticalListArrows, } from '@lean-body/components/molecules/vertical_list_arrows';
import { ProgramComponent } from '../molecules/program_component';
export const ProgramComponentCarousel = ({ programs, classObject, itemMarginRight, itemsPadding, addFavoriteProgram, unFavoriteProgram, isMin, }) => {
    const addFavorite = (program) => {
        program.isFavorited = true;
        addFavoriteProgram(program.id);
    };
    const unFavorite = (program) => {
        program.isFavorited = false;
        unFavoriteProgram(program.id);
    };
    return (React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: isMin ? ITEM_WIDTH_SP : ITEM_WIDTH_OVER_XL, items: programs.map((v) => (React.createElement(ProgramComponent, { program: v, addFavoriteProgram: () => addFavorite(v), unFavoriteProgram: () => unFavorite(v), isMin: isMin }))) }));
};
